import React, { useEffect, useMemo, useState } from "react";
import { Empty, Table, Tag } from "antd";
import moment from "moment";
import { gatewayCRUD } from "../../../../actions/gateway";
import { char, number } from "../../../../utils";
import { re } from "mathjs";

export const CustomerTransaction = (props) => {
  const { dataId } = props;
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
    if (dataId) {
      setLoading(true);
      setTimeout(() => {
        gatewayCRUD
          .loadCustomerTransaction(dataId)
          .then((resp) => {
            setData(resp.data?.results);
          })
          .catch(() => {
            setData([]);
          })
          .finally(() => {
            setLoading(false);
          });
      }, 500);
    }
  }, [dataId]);

  const ledgerData = useMemo(() => {
    let runningBalance = 0;

    return data
      .sort((a, b) => new Date(a.trans_date) - new Date(b.trans_date))
      .map((item, index) => {
        const isDebit = item.entry_type === "debit";

        const debit = isDebit ? item.trans_amount : 0;
        const credit = !isDebit ? item.trans_amount : 0;

        runningBalance += debit - credit;

        return {
          key: index,
          date: item.trans_date,
          control_number: item.control_number,
          description: item.trans_description,
          debit,
          credit,
          balance: runningBalance,
        };
      });
  }, [data]);

  const finalBalance =
    ledgerData.length > 0 ? ledgerData[ledgerData.length - 1].balance : 0;

  const columns = [
    {
      title: "Date",
      dataIndex: "date",
      width: 180,
      render: (date) => moment(date).format("YYYY-MM-DD HH:mm"),
    },
    {
      title: "Control Number",
      dataIndex: "control_number",
      ellipsis: true,
    },
    {
      title: "Description",
      dataIndex: "description",
      ellipsis: true,
      render: (text) => <span>{char.smartTitleCase(text)}</span>,
    },
    {
      title: "Debit (Dr)",
      dataIndex: "debit",
      width: 150,
      align: "right",
      render: (value) => (value > 0 ? number.fNumberDoublePoint(value) : ""),
    },
    {
      title: "Credit (Cr)",
      dataIndex: "credit",
      width: 150,
      align: "right",
      render: (value) => (value > 0 ? number.fNumberDoublePoint(value) : ""),
    },
    {
      title: "Balance",
      dataIndex: "balance",
      width: 160,
      align: "right",
      render: (value) => (
        <span style={{ fontWeight: 600 }}>
          {number.fNumberDoublePoint(value)}
        </span>
      ),
    },
  ];

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <Table
              columns={columns}
              dataSource={ledgerData}
              pagination={false}
              size="small"
              rowKey="control_number"
              bordered
              loading={loading}
              scroll={{
                x: 900,
                y: "60vh",
              }}
              locale={{
                emptyText: <Empty description="No data available" />,
              }}
              className="ledger-table"
            />

            <div style={{ marginTop: 20, textAlign: "right" }}>
              <Tag
                color={
                  finalBalance > 0 ? "red" : finalBalance < 0 ? "blue" : "green"
                }
                style={{ padding: "8px 16px", fontSize: 16 }}
              >
                {finalBalance > 0 && "Customer Should Pay"}
                {finalBalance < 0 && "Customer Should Be Paid"}
                {finalBalance === 0 && "Account Settled"}

                {" : "}
                {number.fNumberDoublePoint(Math.abs(finalBalance))}
              </Tag>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
